import zhinenghua from "../img/zhinenghua.png";
import didaima from "../img/didaima.png";
import dashuju from "../img/dashuju.png";
import wulianwang from "../img/wulianwang.png";
import React from "react";

export const Feature00DataSource = {
    wrapper: {
        className: 'home-page-wrapper content0-wrapper k4niktbygd-editor_css',
    },
    page: { className: 'home-page content0' },
    OverPack: { playScale: -3, className: '' },
    titleWrapper: {
        className: 'title-wrapper',
        children: [{ name: 'title', children: 'ABI平台' }],
        url: '/product',
    },
    childWrapper: {
        className: 'content0-block-wrapper',
        children: [
            {
                name: 'block0',
                className: 'content0-block',
                md: 6,
                xs: 6,
                children: {
                    className: 'content0-block-item',
                    positions: '智能化应用',
                    children: [
                        {
                            name: 'image',
                            className: 'content0-block-icon',
                            children:(
                                <img src={zhinenghua} alt="img"/>
                            ),
                        },
                        {
                            name: 'title',
                            className: 'content0-block-title',
                            children: (
                                <>
                                    <p>智能应用</p>
                                </>
                            ),
                        },
                        {
                            name: 'content',
                            children: (
                                <>
                                    <p>场景式智能化改造</p>
                                </>
                            ),
                        },
                    ],
                },
            },
            // {
            //     name: 'block1',
            //     className: 'content0-block',
            //     md: 6,
            //     xs: 6,
            //     children: {
            //         className: 'content0-block-item',
            //         positions: '低代码开发平台',
            //         children: [
            //             {
            //                 name: 'image',
            //                 className: 'content0-block-icon',
            //                 children:(
            //                     <img src={didaima} alt="img"/>
            //                 ),
            //             },
            //             {
            //                 name: 'title',
            //                 className: 'content0-block-title',
            //                 children: (
            //                     <>
            //                         <p>低代码开发平台</p>
            //                     </>
            //                 ),
            //             },
            //             {
            //                 name: 'content',
            //                 children: (
            //                     <>
            //                         <p>业务应用，快速交付</p>
            //                     </>
            //                 ),
            //             },
            //         ],
            //     },
            // },
            {
                name: 'block2',
                className: 'content0-block',
                md: 6,
                xs: 6,
                children: {
                    className: 'content0-block-item',
                    positions: '大数据应用',
                    children: [
                        {
                            name: 'image',
                            className: 'content0-block-icon',
                            children: (
                                <img src={dashuju} alt="img"/>
                            ),
                        },
                        {
                            name: 'title',
                            className: 'content0-block-title',
                            children: (
                                <>
                                    <p>大数据应用</p>
                                </>
                            ),
                        },
                        {
                            name: 'content',
                            children: (
                                <>
                                    <p>专题型大数据分析</p>
                                </>
                            ),
                        },
                    ],
                },
            },
            {
                name: 'block~k4nj0q29cz',
                className: 'content0-block',
                md: 6,
                xs: 6,
                children: {
                    className: 'content0-block-item',
                    positions: '物联网应用',
                    children: [
                        {
                            name: 'image',
                            className: 'content0-block-icon',
                            children:(
                                <img src={didaima} alt="img"/>
                            ),
                        },
                        {
                            name: 'title',
                            className: 'content0-block-title',
                            children: (
                                <>
                                    <p>物联应用</p>
                                </>
                            ),
                        },
                        {
                            name: 'content',
                            children:
                                <>
                                    <p>感知型物联应用</p>
                                </>,
                        },
                    ],
                },
            },
        ],
    },
};
export default Feature00DataSource;